export default "__VITE_ASSET__BPXvDlBH__"